// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3iPLo","inputDescription":"styles_inputDescription__3-Quq"};